<template>
  <form v-on:submit.prevent="proceed()" class="box orange left-box-sizing text-left">
    <!-- box header -->
    <div class="header">
      <span class="step mx-2 mx-md-4">1</span>
      <h2>Delivery Information</h2>
    </div>

    <!-- box-content -->
    <div class="content">
      <div class="my-4 my-md-5 px-3 px-lg-5">
        <div class="form">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="">
                <div class="input-group">
                  <input
                    class="text w-100"
                    type="text"
                    name="fname"
                    id="fname"
                    v-model="$v.fname.$model"
                    @blur="giveName()"
                    :disabled="isLoggedIn"
                  >
                  <label :class="[$v.fname.$model=='' ? '' : 'filled', 'label']" for="fname">First Name*</label>
                </div>
                <small v-if="$v.fname.$dirty && $v.fname.$invalid" class="input-error text-danger">
                  (Please enter valid first name)
                </small>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="mt-4 mt-md-0">
                <div class="input-group">
                  <input
                    class="text w-100"
                    type="text"
                    name="lname"
                    id="lname"
                    v-model="$v.lname.$model"
                    :disabled="isLoggedIn"
                  >
                  <label :class="[$v.lname.$model=='' ? '' : 'filled', 'label']" for="lname">Last Name</label>
                </div>
                <small v-if="$v.lname.$dirty && $v.lname.$invalid" class="input-error text-danger">
                  (Please enter valid last name)
                </small>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 col-md-4">
              <div class="mt-2 mt-md-0">
                <div class="input-group">
                  <input
                    class="text w-100"
                    type="number"
                    name="phone"
                    id="phone"
                    v-model="$v.phone.$model"
                    pattern="[0-9]{10}"
                    required
                    :disabled="isLoggedIn"
                  >
                  <label :class="[$v.phone.$model=='' ? '' : 'filled', 'label']" for="phone" maxlength="10">Phone No.*</label>
                </div>
                <small v-if="$v.phone.$dirty && $v.phone.$invalid" class="input-error text-danger">
                  (Please enter a valid 10 digit phone number)
                </small>
              </div>
            </div>
            <div class="col-12 col-md-8">
              <div class="mt-4 mt-md-0">
                <div class="input-group">
                  <input
                    class="text w-100"
                    type="text"
                    name="email"
                    id="email"
                    v-model="$v.email.$model"
                    :disabled="isLoggedIn"
                  >
                  <label :class="[$v.email.$model=='' ? '' : 'filled', 'label']" for="email">Email ID</label>
                </div>
                <small v-if="$v.email.$dirty && $v.email.$invalid" class="input-error text-danger">
                  (Please enter a valid email ID)
                </small>
              </div>
            </div>
            <!-- <div class="row mt-3">
              <div class="col-12">
                <div class="mt-4 mt-md-0">
                  <div class="input-group">
                    <input
                      class="text w-100"
                      type="number"
                      name="pin"
                      id="pin"
                      v-model="$v.email.$pin"
                      required
                    >
                    <label :class="[$v.pin.$model=='' ? '' : 'filled', 'label']" for="pin">Pin Code*</label>
                  </div>
                  <small v-if="$v.pin.$dirty && $v.pin.$invalid" class="input-error text-danger">
                    (Please enter a valid Pin Code)
                  </small>
                </div>
              </div>
            </div> -->
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <div class="mt-2 mt-md-0">
                <div class="input-group">
                  <input
                    class="text w-100"
                    type="number"
                    name="pin"
                    id="pin"
                    v-model="$v.pin.$model"
                    required
                    @focus="invalidPin=false"
                  >
                  <label :class="[$v.pin.$model=='' ? '' : 'filled', 'label']" for="pin">Pin Code*</label>
                </div>
                <small v-if="$v.pin.$dirty && $v.pin.$invalid || invalidPin" class="input-error text-danger">
                  (Please enter a valid Pin Code)
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- box footer -->
    <div class="footer">
      <div class="px-3 form">
        <small class="ml-2 ml-md-5" style="color: #909090;">
          * Indicates Mandatory Fields
        </small>
        <input
          class="mx-sm-auto ml-md-auto mr-md-0"
          type="submit"
          :value="buttonValue"
          :disabled="$v.$invalid"
        >
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { alpha, email, minLength, maxLength, numeric, required } from 'vuelidate/lib/validators'

export default {
  name: "DeliveryBox",
  data() {
    return {
      fname: '',
      lname: '',
      phone: '',
      email: '',
      pin: '',

      buttonValue: 'Continue',
      invalidPin: false,
    }
  },
  props: ["is-logged-in", "user"],
  mixins: [validationMixin],
  validations: {
    fname: {
      required,
      alpha,
    },
    lname: {
      alpha
    },
    phone: {
      numeric,
      maxLength: maxLength(10),
      minLength: minLength(10),
      required,
    },
    email: {
      email,
    },
    pin: {
      numeric,
      maxLength: maxLength(6),
      minLength: minLength(6),
      required,
    }
  },
  methods: {
    ...mapActions(["checkPincode"]),
    proceed() {
      // console.log('delivery-box-proceed');
      // console.log(this.$v)
      // this.$v.$touch();
      this.buttonValue = 'Validating...'
      this.checkPincode(this.$v.pin.$model)
      .then((res) => {
        this.buttonValue = 'Continue';
        if (res=='success')
        if (!this.$v.$invalid) this.$emit('personal', {
          fname: this.$v.fname.$model,
          lname: this.$v.lname.$model,
          phone: this.$v.phone.$model,
          email: this.$v.email.$model,
          pin: this.$v.pin.$model,
        })
      })
      .catch(() => {
        this.invalidPin = true;
        this.buttonValue = 'Continue'
        // console.log(err);
      })
    },
    giveName() {
      if (!this.$v.fname.$invalid) this.$emit('name', this.$v.fname.$model);
    },
  },
  created() {
    // console.log(this.isLoggedIn, this.user);
    if (this.isLoggedIn) {
      this.$v.fname.$model = this.user.fname;
      this.$v.lname.$model = this.user.lname;
      this.$v.phone.$model = this.user.phone;
      this.$v.email.$model = this.user.email;
      this.$v.pin.$model = this.user.pin;
    }
  },
}
</script>

<style scoped>
  .box > .header > .step {
    color:#fff;
    border-radius: 1000px;
    background: #f36f2e;
    height: 36px;
    width: 36px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .box > .content {
    overflow: hidden;
  }

  .input-group {
    position: relative;
  }

  .input-group > .label {
    position: absolute;
  }
  .input-group > .text:hover, .label:hover {
    cursor: pointer;
  }

  .text {
    outline: none;
    padding: 10px;
    border-radius: 4px;
    border: solid 1px #A0A0A0;
    /* width: 100%; */
  }

  .label {
    padding: 11px;
    top: 0;
    left: 0;
    transition: all 0.5s;
    color: #A0A0A0;
    white-space: nowrap;
  }

  .text:focus {
    border: solid 1px #F36F2E;
  }
  /* .text:focus:read-only {
    border: solid 1px #a0a0a0;
  } */
  .text:disabled {
    background-color: #e0e0e0;
  }

  .text:focus ~ .label {
    padding: 0 4px;
    font-size: 0.8rem;
    top: -0.4rem;
    left: 0.4rem;
    background: #fff;
    color: #F36F2E;
    
    transition: all 0.5s;
  }
  .text:focus:read-only ~ .label {
    color: #a0a0a0;
  }

  .filled {
    padding: 0 4px;
    font-size: 0.8rem;
    top: -0.4rem;
    left: 0.4rem;
    background: #fff;
  }
</style>